import React, { useState, useEffect } from "react";
import api from "../../../../services/api";
import { sourceImage } from "../../../../utils/source-image";
export default function AdminCardapio(props) {
  const institutionContext = props.institutionContext;
  const institutionApi = institutionContext?.http || api;
  let cardapio = props.cardapio;
  let setCardapio = props.setCardapio;
  let showFlash = props.showFlash;
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({
    nome: "",
    categoria: "salgado",
    preco: "",
    custo_token: "",
    estoque: "",
    descricao: "",
    foto: null,
    ativo: true,
  });
  const [imgPrev, setImgPrev] = useState(null);
  const [filtro, setFiltro] = useState("todos");
  useEffect(() => {
    if (editId) {
      const item = (cardapio || []).find((itemId) => itemId.id === editId);
      if (item) {
        setForm({
          ...item,
          preco: null === item.preco ? "" : String(item.preco),
          custo_token:
            null === item.custo_token ? "" : String(item.custo_token),
          estoque: null === item.estoque ? "" : String(item.estoque),
        });
        setImgPrev(item.foto || null);
      }
    } else {
      setForm({
        nome: "",
        categoria: "salgado",
        preco: "",
        custo_token: "",
        estoque: "",
        descricao: "",
        foto: null,
        ativo: true,
      });
      setImgPrev(null);
    }
  }, [editId, cardapio]);
  const corCat = {
    salgado: "#FF8C42",
    doce: "#EC4899",
    bebida: "#3B82F6",
  };
  const itensFilt = (cardapio || []).filter(
    (item) => "todos" === filtro || item.categoria === filtro,
  );
  return (
    <div className={"ga"}>
      <div>
        <div
          className={"tabs"}
          style={{
            marginBottom: 12,
          }}
        >
          {[
            {
              id: "todos",
              label: "Todos",
            },
            {
              id: "salgado",
              label: "Salgados",
            },
            {
              id: "doce",
              label: "Doces",
            },
            {
              id: "bebida",
              label: "Bebidas",
            },
          ].map((item) => (
            <button
              className={filtro === item.id ? "a" : ""}
              onClick={() => setFiltro(item.id)}
              style={{
                fontSize: 11,
              }}
              key={item.id}
            >
              {item.label}
              {" ("}
              {filtro === item.id
                ? itensFilt.length
                : (cardapio || []).filter(
                    (itemCategoria) =>
                      "todos" === item.id ||
                      itemCategoria.categoria === item.id,
                  ).length}
              {")"}
            </button>
          ))}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          {itensFilt.map((item) => (
            <div
              style={{
                background: "#FFF",
                borderRadius: 11,
                overflow: "hidden",
                boxShadow: "0 1px 6px rgba(0,0,0,.07)",
                opacity: item.ativo ? 1 : 0.5,
                display: "flex",
                alignItems: "stretch",
                gap: 0,
              }}
              key={item.id}
            >
              {item.foto && (
                <img
                  src={sourceImage(item.foto)}
                  alt={item.nome}
                  style={{
                    width: 64,
                    height: 64,
                    objectFit: "cover",
                    flexShrink: 0,
                  }}
                />
              )}
              {!item.foto && (
                <div
                  style={{
                    width: 64,
                    flexShrink: 0,
                    background: corCat[item.categoria] + "22",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 10,
                    fontWeight: 700,
                    color: corCat[item.categoria],
                    padding: 6,
                    textAlign: "center",
                  }}
                >
                  {item.categoria}
                </div>
              )}
              <div
                style={{
                  flex: 1,
                  padding: "9px 11px",
                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: 6,
                  }}
                >
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#1F4754",
                      fontSize: 13,
                    }}
                  >
                    {item.nome}
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      flexShrink: 0,
                    }}
                  >
                    {null !== item.preco && undefined !== item.preco && (
                      <div
                        style={{
                          fontWeight: 800,
                          color: "#4FB3A9",
                          fontSize: 14,
                        }}
                      >
                        {"R$ "}
                        {Number(item.preco).toFixed(2).replace(".", ",")}
                      </div>
                    )}
                    {null !== item.custo_token &&
                      undefined !== item.custo_token && (
                        <div
                          style={{
                            fontWeight: 700,
                            color: "#9B59B6",
                            fontSize: 12,
                          }}
                        >
                          {item.custo_token}
                          {" tokens"}
                          {null !== item.estoque && undefined !== item.estoque
                            ? " (".concat(item.estoque, " em estoque)")
                            : ""}
                        </div>
                      )}
                  </div>
                </div>
                {item.descricao && (
                  <div
                    style={{
                      fontSize: 11,
                      color: "#6B8590",
                      marginTop: 2,
                    }}
                  >
                    {item.descricao}
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    gap: 5,
                    marginTop: 7,
                  }}
                >
                  <button
                    className={"btn bg bs"}
                    style={{
                      fontSize: 10,
                      padding: "4px 9px",
                    }}
                    onClick={() => setEditId(item.id)}
                  >
                    {"Editar"}
                  </button>
                  <button
                    className={"btn bs"}
                    style={{
                      fontSize: 10,
                      padding: "4px 9px",
                      background: item.ativo ? "#F59E0B" : "#4FB3A9",
                    }}
                    onClick={() =>
                      (async (resultado) => {
                        const atual = (cardapio || []).find(
                          (itemId) => itemId.id === resultado,
                        );
                        if (atual)
                          try {
                            const responseData2 = await institutionApi.put(
                              "/cardapio?id=".concat(resultado),
                              {
                                ...atual,
                                ativo: !atual.ativo,
                              },
                            );
                            const saved =
                              responseData2.data?.data ?? responseData2.data;
                            setCardapio(
                              (cardapio || []).map((itemId) =>
                                itemId.id === resultado ? saved : itemId,
                              ),
                            );
                          } catch (err) {
                            showFlash(
                              err.response?.data?.message ||
                                "Nao foi possivel alterar visibilidade do item.",
                              "er",
                            );
                          }
                      })(item.id)
                    }
                  >
                    {item.ativo ? "Ocultar" : "Mostrar"}
                  </button>
                  <button
                    className={"btn bd bs"}
                    style={{
                      fontSize: 10,
                      padding: "4px 9px",
                    }}
                    onClick={() =>
                      (async (resultado) => {
                        try {
                          await institutionApi.delete(
                            "/cardapio?id=".concat(resultado),
                          );
                          setCardapio(
                            (cardapio || []).filter(
                              (itemId) => itemId.id !== resultado,
                            ),
                          );
                          showFlash("Item desativado.", "in");
                        } catch (err) {
                          showFlash(
                            err.response?.data?.message ||
                              "Nao foi possivel remover o item do cardapio.",
                            "er",
                          );
                        }
                      })(item.id)
                    }
                  >
                    {institutionContext ? "Desativar" : "X"}
                  </button>
                </div>
              </div>
            </div>
          ))}
          {0 === itensFilt.length && (
            <div className={"es"}>
              <h3>{"Nenhum item nesta categoria"}</h3>
            </div>
          )}
        </div>
      </div>
      <form
        className={"fc"}
        onSubmit={async (event) => {
          event.preventDefault();
          if (!form.nome.trim()) {
            showFlash("Nome obrigatório.", "er");
            return;
          }
          const precoStr = String(form.preco ?? "").trim();
          const custoTokenStr = String(form.custo_token ?? "").trim();
          const estoqueStr = String(form.estoque ?? "").trim();
          let preco = null;
          if (
            precoStr &&
            ((preco = parseFloat(precoStr.replace(",", "."))),
            isNaN(preco) || preco < 0)
          ) {
            showFlash("Preço inválido.", "er");
            return;
          }
          let custoToken = null;
          if (
            custoTokenStr &&
            ((custoToken = parseFloat(custoTokenStr.replace(",", "."))),
            isNaN(custoToken) || custoToken < 0)
          ) {
            showFlash("Custo em tokens inválido.", "er");
            return;
          }
          if (null === preco && null === custoToken) {
            showFlash("Informe um preço em R$ e/ou um custo em tokens.", "er");
            return;
          }
          let estoque = null;
          if (
            estoqueStr &&
            ((estoque = parseInt(estoqueStr, 10)),
            isNaN(estoque) || estoque < 0)
          ) {
            showFlash("Estoque inválido.", "er");
            return;
          }
          const dados = {
            ...form,
            nome: form.nome.trim(),
            descricao: form.descricao.trim(),
            preco,
            custo_token: custoToken,
            estoque,
          };
          try {
            const responseData2 = editId
              ? await institutionApi.put("/cardapio?id=".concat(editId), dados)
              : await institutionApi.post("/cardapio", dados);
            const saved = responseData2.data?.data ?? responseData2.data;
            if (editId) {
              setCardapio(
                (cardapio || []).map((item) =>
                  item.id === editId ? saved : item,
                ),
              );
              showFlash("Item atualizado!");
              setEditId(null);
            } else {
              setCardapio((prev) => [...prev, saved]);
              showFlash("Item criado!");
              setForm({
                nome: "",
                categoria: "salgado",
                preco: "",
                custo_token: "",
                estoque: "",
                descricao: "",
                foto: null,
                ativo: true,
              });
              setImgPrev(null);
            }
          } catch (err) {
            showFlash(
              err.response?.data?.message ||
                "Nao foi possivel salvar o item do cardapio.",
              "er",
            );
          }
        }}
      >
        <div
          style={{
            fontWeight: 800,
            color: "#1F4754",
            fontSize: 15,
            marginBottom: 12,
          }}
        >
          {institutionContext?.catalog === "loja"
            ? editId
              ? "Editar recompensa"
              : "Nova recompensa"
            : editId
              ? "Editar Item"
              : "Novo Item"}
        </div>
        {imgPrev && (
          <img
            src={sourceImage(imgPrev)}
            alt={""}
            style={{
              width: "100%",
              height: 130,
              objectFit: "cover",
              borderRadius: 10,
              marginBottom: 10,
            }}
          />
        )}
        <div className={"fg"}>
          <label>{"Foto (opcional)"}</label>
          <input
            type={"file"}
            accept={"image/*"}
            className={"inp"}
            onChange={(event) => {
              const item = event.target.files[0];
              if (!item) return;
              const instance = new FileReader();
              instance.onload = (eventTarget) => {
                setImgPrev(eventTarget.target.result);
                setForm((resultado) => ({
                  ...resultado,
                  foto: eventTarget.target.result,
                }));
              };
              instance.readAsDataURL(item);
            }}
          />
        </div>
        <div className={"fg"}>
          <label>{"Nome *"}</label>
          <input
            className={"inp"}
            value={form.nome}
            onChange={(event) =>
              setForm({
                ...form,
                nome: event.target.value,
              })
            }
            required={true}
            placeholder={
              institutionContext?.catalog === "loja"
                ? "Por exemplo: caderno, jogo..."
                : "Por exemplo: coxinha, suco de laranja..."
            }
          />
        </div>
        <div className={"fr"}>
          <div
            className={
              "fg" +
              (institutionContext?.catalog === "loja" ? " native-hide" : "")
            }
          >
            <label>{"Categoria *"}</label>
            <select
              className={"sel"}
              value={form.categoria}
              onChange={(event) =>
                setForm({
                  ...form,
                  categoria: event.target.value,
                })
              }
            >
              <option value={"salgado"}>{"Salgado"}</option>
              <option value={"doce"}>{"Doce"}</option>
              <option value={"bebida"}>{"Bebida"}</option>
            </select>
          </div>
          <div
            className={
              "fg" +
              (institutionContext?.catalog === "loja" ? " native-hide" : "")
            }
          >
            <label>{"Preço (R$)"}</label>
            <input
              type={"number"}
              step={"0.01"}
              min={"0"}
              className={"inp"}
              value={form.preco}
              onChange={(event) =>
                setForm({
                  ...form,
                  preco: event.target.value,
                })
              }
              placeholder={"Ex: 5.00"}
            />
          </div>
        </div>
        <div className={"fr"}>
          <div className={"fg"}>
            <label>{"Custo em tokens"}</label>
            <input
              type={"number"}
              step={"1"}
              min={"0"}
              className={"inp"}
              value={form.custo_token}
              onChange={(event) =>
                setForm({
                  ...form,
                  custo_token: event.target.value,
                })
              }
              placeholder={"Ex: 100"}
            />
          </div>
          <div className={"fg"}>
            <label>{"Estoque para resgate em tokens"}</label>
            <input
              type={"number"}
              step={"1"}
              min={"0"}
              className={"inp"}
              value={form.estoque}
              onChange={(event) =>
                setForm({
                  ...form,
                  estoque: event.target.value,
                })
              }
              placeholder={"Deixe em branco p/ ilimitado"}
            />
          </div>
        </div>
        <div className={"fg"}>
          <label>{"Descrição"}</label>
          <input
            className={"inp"}
            value={form.descricao}
            onChange={(event) =>
              setForm({
                ...form,
                descricao: event.target.value,
              })
            }
            placeholder={"Breve descrição do item"}
          />
        </div>
        <div className={"fg"}>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              cursor: "pointer",
            }}
          >
            <input
              type={"checkbox"}
              checked={form.ativo}
              onChange={(event) =>
                setForm({
                  ...form,
                  ativo: event.target.checked,
                })
              }
            />
            <span>
              {institutionContext?.catalog === "loja"
                ? "Visível nas recompensas"
                : "Visível no cardápio"}
            </span>
          </label>
        </div>
        <div
          style={{
            display: "flex",
            gap: 8,
          }}
        >
          <button type={"submit"} className={"btn"}>
            {editId
              ? "Atualizar"
              : institutionContext?.catalog === "loja"
                ? "Adicionar recompensa"
                : "Adicionar ao Cardápio"}
          </button>
          {editId && (
            <button
              type={"button"}
              className={"btn bg"}
              onClick={() => setEditId(null)}
            >
              {"Cancelar"}
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
export { AdminCardapio };
